import { render, staticRenderFns } from "./evaluate-item.vue?vue&type=template&id=633b0d1a&scoped=true"
import script from "./evaluate-item.vue?vue&type=script&lang=js"
export * from "./evaluate-item.vue?vue&type=script&lang=js"
import style0 from "./evaluate-item.vue?vue&type=style&index=0&id=633b0d1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b0d1a",
  null
  
)

export default component.exports